export default __webpack_public_path__ + "static/logo-37e83f54f7f6763b674ca59a69c24c62.svg";